import {capitalize} from 'lodash';
import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {Banner, BannerTypesEnum} from '../../../../libs/shared/ui/src/components/banners/banner';
import {BannerAction} from '../../../../libs/shared/ui/src/components/banners/bannerAction';
import {BannerContent} from '../../../../libs/shared/ui/src/components/banners/bannerContent';
import {BannerFooterActions} from '../../../../libs/shared/ui/src/components/banners/bannerFooterActions';
import {BannerPrioritiesEnum} from '../../../../libs/shared/ui/src/components/banners/bannersContext';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface IncomingCallBannerProps {
  contactHandle: string;
  actionText: string;
  onActionClick: () => void;
  icon: ReactNode;
  contactName?: string;
}

/*
 * Style.
 */

const StyledBannerIcon = styled.div`
  grid-area: icon;
  margin: 2px 0;
`;

const StyledBannerContent = styled(BannerContent)`
  position: relative;
  grid-area: content;

  color: ${(p) => p.theme.greys.white};
  font-size: ${fontSizes.small};
`;

const StyledBannerTitle = styled.div`
  font-weight: ${fontWeights.bold};
  padding-bottom: 4px;
`;

const StyledBannerText = styled.div`
  line-height: 17px;
  font-weight: ${fontWeights.medium};
`;

const StyledBannerAction = styled(BannerAction)`
  color: ${(p) => p.theme.greys.white};
`;

/*
 * Component.
 */

export const IncomingCallBanner: FC<IncomingCallBannerProps> = (props) => {
  const {icon, actionText, onActionClick, contactName, contactHandle} = props;

  const theme = useUserTheme();

  return (
    <Banner
      bannerType={BannerTypesEnum.MULTILINE}
      color={theme.greys.shade90}
      priority={BannerPrioritiesEnum.TRANSIENT}
    >
      <StyledBannerIcon>{icon}</StyledBannerIcon>
      <StyledBannerContent>
        <StyledBannerTitle>
          <Trans id="incoming-call">Incoming call</Trans>
        </StyledBannerTitle>
        {contactName && <StyledBannerText>{contactName}</StyledBannerText>}
        <StyledBannerText>{contactHandle}</StyledBannerText>
      </StyledBannerContent>
      <BannerFooterActions>
        <StyledBannerAction onClick={onActionClick}>{capitalize(actionText)}</StyledBannerAction>
      </BannerFooterActions>
    </Banner>
  );
};
